import {deletePopover} from "../../../hoc/deletePopover";

const CashBoxCashInDeleteModal = deletePopover("CashBoxCashInDeleteModal")

export default CashBoxCashInDeleteModal
